import React from 'react';
import GoogleMapComponent from './Map.tsx';

const App: React.FC = () => {
  return (
    <div className="App">
      <GoogleMapComponent apiKey="AIzaSyA99rKfvaEsVGUCG3Z2-GH_4nz4-M4z1NI" />
    </div>
  );
};

export default App;